module.exports = __webpack_public_path__ + "img/W7008-full.8df6469c.jpg";